import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor: FaireCategoryEntity = {
  token: "cat_home-decor",
  type: "category",
  name: "Home decor",
  level: 1,
  href: "/category/home-decor",
  childCategoryTokens: [
    "cat_home-decor-all",
    "cat_home-decor-new-products",
    "cat_home-decor-new-brands",
    "cat_home-decor-bestsellers",
    "cat_home-decor-kitchen-tabletop",
    "cat_home-decor-accents",
    "cat_home-decor-candles",
    "cat_home-decor-garden",
    "cat_home-decor-household",
    "cat_home-decor-wall",
    "cat_home-decor-fragrances",
    "cat_home-decor-storage",
    "cat_home-decor-pillows",
    "cat_home-decor-bath",
    "cat_home-decor-bedding",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
